/* eslint-disable react/require-default-props */
import {
  Page,
  Text,
  View,
  Document,
  Image,
  PDFDownloadLink,
  StyleSheet,
  pdf,
} from '@react-pdf/renderer';
import Button from '@material-ui/core/Button/Button';
import ImageTable from 'packages/assets/images/GameRegisterTable.png';
import {
  TableWorker,
  Result,
  Tournament,
} from 'packages/common-types/schema-types';
import {retrieveMemberNames} from 'packages/common-utils/helpers';
import JSZip from 'jszip';
import {v4 as uuidv4} from 'uuid';
import {saveAs} from 'file-saver';
import {
  selectGeneratedRound,
  selectRoundMetadata,
} from 'redux/features/round-slice';
import {useState} from 'react';
import useAppSelector from 'packages/hooks/use-app-selector';
import {GeneratedRound} from 'packages/common-types/base-types';
import {selectFileBlob, selectTournament} from 'redux/features/app-slice';

type Props = {
  modalityGame: string;
  // eslint-disable-next-line react/no-unused-prop-types
  prevCurrentTable?: Result;
  currentTable: TableWorker | null;
};

type GameReportDownloadProps = Props & {
  selectedTable: any;
};

type PDFDocumentProps = {
  modalityGame: string;
  currentTable: TableWorker | null;
  currentRound: number;
  sponsorsUrls: string[];
};

// Styles for the game report.
const styles = StyleSheet.create({
  page: {
    marginTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    flexDirection: 'column',
    backgroundColor: '#fff',
  },
  row: {
    // flex: 1,
    flexDirection: 'row',
  },
  centered: {
    width: '100%',
    position: 'relative',
  },
  fill_names_container: {
    flex: 1,
    flexDirection: 'column',
  },
  fontx10: {
    fontSize: 10,
  },
  fontx12: {
    fontSize: 12,
  },
  fontx14: {
    fontSize: 14,
  },
  field: {
    flex: 1,
    borderWidth: 1,
    flexDirection: 'row',
    borderColor: '#000',
    height: 'auto',
    borderStyle: 'solid',
  },
  field_square: {
    borderRightColor: '#000',
    borderRightStyle: 'solid',
    borderRight: 1,
    height: '100%',
  },
});

const PDFDocument = ({
  modalityGame,
  currentTable,
  currentRound,
  sponsorsUrls,
}: PDFDocumentProps) => {
  const {competitorOne, competitorTwo, tableNumber} = currentTable;

  const {
    matchesWon: athleteAOneWon,
    matchesLose: athleteAOneLose,
    pointDifference: athleteAOneDifference,
    groupNumber: athleteAOneGroupNumber,
  } = competitorOne[0];

  const {
    matchesWon: athleteBOneWon,
    matchesLose: athleteBOneLose,
    pointDifference: athleteBOneDifference,
    groupNumber: athleteBOneGroupNumber,
  } = competitorOne[1] || {};

  const {
    matchesWon: athleteATwoWon,
    matchesLose: athleteATwoLose,
    pointDifference: athleteATwoDifference,
    groupNumber: athleteATwoGroupNumber,
  } = competitorTwo[0];
  const {
    matchesWon: athleteBTwoWon,
    matchesLose: athleteBTwoLose,
    pointDifference: athleteBTwoDifference,
    groupNumber: athleteBTwoGroupNumber,
  } = competitorTwo[1] || {};

  const [athleteAOne, athleteBOne] =
    retrieveMemberNames(competitorOne).split(',');
  const [athleteATwo, athleteBTwo] =
    retrieveMemberNames(competitorTwo).split(',');
  // TODO: Validate when is loadedRound or generatedRound.

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.row]}>
          <View style={styles.fill_names_container}>
            {/* G/P/Eff container */}
            <View style={[styles.row, {justifyContent: 'space-between'}]}>
              <Text style={[styles.fontx10]}>G/P/Eff</Text>
              <Text style={[styles.fontx10]}>
                {modalityGame === 'Individual' ? 'Atleta' : 'Pareja'}
              </Text>
            </View>

            {/* Row names  */}
            <View style={[styles.field]}>
              {/* G/P/Eff Col 1 */}
              <Text
                style={[styles.field_square, styles.fontx10]}
              >{`${athleteAOneWon}/${athleteAOneLose}/${athleteAOneDifference}`}</Text>

              {/* Names Col 1 */}
              <Text
                style={[
                  styles.field_square,
                  {flexGrow: 1, fontSize: 10, alignItems: 'center'},
                ]}
              >
                {modalityGame === 'Individual'
                  ? athleteAOne
                  : `${athleteAOne},${athleteBOne}`}
              </Text>

              {/* Atlete commentd */}
              <Text style={[styles.field_square, styles.fontx10]}>{`${
                athleteAOneGroupNumber + 1
              }`}</Text>
            </View>

            {/* If individual, render the other player */}

            {modalityGame === 'Individual' ? (
              <>
                <View
                  style={[
                    styles.row,
                    {justifyContent: 'space-between', marginTop: 10},
                  ]}
                >
                  <Text style={[styles.fontx10]}>G/P/Eff</Text>
                  <Text style={[styles.fontx10]}>
                    {modalityGame === 'Individual' ? 'Atleta' : 'Pareja'}
                  </Text>
                </View>
                <View style={styles.field}>
                  <Text style={[styles.field_square, styles.fontx10]}>
                    {`${athleteBOneWon}/${athleteBOneLose}/${athleteBOneDifference}`}
                  </Text>
                  <Text
                    style={[
                      styles.field_square,
                      {flexGrow: 1, fontSize: 10, alignItems: 'center'},
                    ]}
                  >
                    {athleteBOne}
                  </Text>
                  <Text style={[styles.field_square, styles.fontx10]}>
                    {`${athleteBOneGroupNumber + 1}`}
                  </Text>
                </View>
              </>
            ) : null}
          </View>

          <View style={[styles.fill_names_container, {marginLeft: 20}]}>
            <View style={[styles.row, {justifyContent: 'space-between'}]}>
              <Text style={[styles.fontx10]}>G/P/Eff</Text>
              <Text style={[styles.fontx10]}>
                {modalityGame === 'Individual' ? 'Atleta' : 'Pareja'}
              </Text>
            </View>
            <View style={[styles.field]}>
              <Text
                style={[styles.field_square, styles.fontx10]}
              >{`${athleteATwoWon}/${athleteATwoLose}/${athleteATwoDifference}`}</Text>
              <Text
                style={[
                  styles.field_square,
                  {flexGrow: 1, fontSize: 10, alignItems: 'center'},
                ]}
              >
                {modalityGame === 'Individual'
                  ? athleteATwo
                  : `${athleteATwo},${athleteBTwo}`}
              </Text>
              <Text style={[styles.field_square, styles.fontx10]}>{`${
                athleteATwoGroupNumber + 1
              }`}</Text>
            </View>
            {modalityGame === 'Individual' && (
              <>
                <View
                  style={[
                    styles.row,
                    {justifyContent: 'space-between', marginTop: 10},
                  ]}
                >
                  <Text style={[styles.fontx10]}>G/P/Eff</Text>
                  <Text style={[styles.fontx10]}>
                    {modalityGame === 'Individual' ? 'Atleta' : 'Pareja'}
                  </Text>
                </View>
                <View style={[styles.field]}>
                  <Text
                    style={[styles.field_square, styles.fontx10]}
                  >{`${athleteBTwoWon}/${athleteBTwoLose}/${athleteBTwoDifference}`}</Text>
                  <Text
                    style={[
                      styles.field_square,
                      {flexGrow: 1, fontSize: 10, alignItems: 'center'},
                    ]}
                  >
                    {athleteBTwo}
                  </Text>
                  <Text style={[styles.field_square, styles.fontx10]}>{`${
                    athleteBTwoGroupNumber + 1
                  }`}</Text>
                </View>
              </>
            )}
          </View>
        </View>

        {/* Second section */}
        <View style={[styles.row, {flexGrow: 0, marginVertical: 10}]}>
          <View style={styles.row}>
            <Text style={[styles.fontx12]}>Mesa: {tableNumber + 1},</Text>
          </View>
          <View style={styles.row}>
            <Text style={[styles.fontx12]}>Ronda: {currentRound} </Text>
          </View>
        </View>

        {/* Image section */}
        <View style={[{marginTop: 5}, styles.centered]}>
          <Image style={{width: '100%', height: 'auto'}} src={ImageTable} />
        </View>

        {/* Sign section */}
        {modalityGame === 'Individual' ? (
          <>
            <View style={{paddingTop: 20}}>
              <View
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  paddingBottom: 10,
                }}
              >
                <View style={{flexDirection: 'column', flex: 1}}>
                  <Text style={[styles.fontx10]}>
                    Firma {athleteAOne}: _____________________
                  </Text>
                </View>
                <View style={{flexDirection: 'column', flex: 1}}>
                  <Text style={[styles.fontx10]}>
                    Firma {athleteATwo}: _____________________
                  </Text>
                </View>
              </View>

              <View
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  marginBottom: 10,
                }}
              >
                <View style={{flexDirection: 'column', flex: 1}}>
                  <Text style={[styles.fontx10]}>
                    Firma {athleteBOne}: _____________________
                  </Text>
                </View>
                <View style={{flexDirection: 'column', flex: 1}}>
                  <Text style={[styles.fontx10]}>
                    Firma {athleteBTwo}: _____________________
                  </Text>
                </View>
              </View>
            </View>
          </>
        ) : (
          <>
            <View style={[styles.row, {paddingTop: 20, flexGrow: 0}]}>
              <View style={styles.row}>
                <Text style={[styles.fontx10]}>
                  Firma capitán A: _______________________
                </Text>
              </View>
              <View style={styles.row}>
                <Text style={[styles.fontx10]}>
                  Firma capitán B: _______________________
                </Text>
              </View>
            </View>
          </>
        )}

        <View style={[styles.row, {paddingTop: 10}]}>
          <Text style={[styles.fontx10]}>
            Firma Juez de Mesa: __________________________________
          </Text>
        </View>

        {/* Sponsors section */}
        <View style={[styles.row, {paddingTop: 50}]}>
          {sponsorsUrls?.map((blobUrl) => {
            return (
              <Image
                style={{width: 120, height: '100%', objectFit: 'fit'}}
                key={uuidv4()}
                src={blobUrl}
              />
            );
          })}
        </View>
      </Page>
    </Document>
  );
};

const GameReportDownload = ({
  modalityGame,
  currentTable,
  selectedTable,
}: GameReportDownloadProps) => {
  const generatedRound = useAppSelector(selectGeneratedRound);
  const selectedTournament = useAppSelector(selectTournament);
  const {currentRound} = useAppSelector(selectRoundMetadata);
  const sponsorsUrls = useAppSelector(selectFileBlob);
  const [generatingAll, setGeneratingAll] = useState(false);

  const handleDownloadAll = async ({
    current,
    selectedTournament,
  }: {
    current: GeneratedRound;
    selectedTournament: Tournament;
  }) => {
    const zip = new JSZip();

    const {
      conditions: {modalityGame},
    } = selectedTournament || {};

    if (current) {
      current.tables.forEach((elem, i) => {
        zip.file(
          `mesa_${i + 1}.pdf`,
          pdf(
            <PDFDocument
              sponsorsUrls={sponsorsUrls}
              currentRound={currentRound}
              currentTable={elem}
              modalityGame={modalityGame}
            />
          ).toBlob()
        );
      });
    }
    try {
      setGeneratingAll(true);
      await zip.generateAsync({type: 'blob'}).then((blob) => {
        saveAs(blob, `actas_de_juego_ronda_${currentRound}.zip`);
      });
      setGeneratingAll(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {selectedTable ? (
        <PDFDownloadLink
          document={
            <PDFDocument
              sponsorsUrls={sponsorsUrls}
              currentRound={currentRound}
              currentTable={currentTable}
              modalityGame={modalityGame}
            />
          }
          fileName={`acta_de_juego_${new Date()}.pdf`}
        >
          {({loading}) =>
            loading ? (
              'Loading document...'
            ) : (
              <Button disabled={generatingAll} fullWidth>
                Descargar individual
              </Button>
            )
          }
        </PDFDownloadLink>
      ) : null}

      <Button
        disabled={generatingAll}
        onClick={() =>
          handleDownloadAll({
            current: generatedRound,
            selectedTournament,
          })
        }
      >
        {generatingAll ? 'Descargando...' : 'Descargar todos'}
      </Button>
    </>
  );
};

export default GameReportDownload;
